'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { CardDashboardLoading } from '@/components/common/Card/CardDashboard';
import { useDashboardContext } from '@/contexts/Dashboard/Dashboard.context';
const BorrowDashboardCardChartSkeleton = () => {
  const $ = _c(3);
  const {
    isDashboardExpanded,
    isSmallDashboard
  } = useDashboardContext();
  let t0;
  if ($[0] !== isDashboardExpanded || $[1] !== isSmallDashboard) {
    t0 = <CardDashboardLoading isExpanded={isDashboardExpanded} isSmallDashboard={isSmallDashboard} />;
    $[0] = isDashboardExpanded;
    $[1] = isSmallDashboard;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default memo(BorrowDashboardCardChartSkeleton);